/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Tabs } from './Tabs'
import { Outlet } from 'react-router-dom-v5-compat'
import { ActionsBar } from './ActionsBar/ActionsBar'

const Products = () => {
    return (
      <>
          <div
            css={css`
                display: flex;
                align-items: center;
                justify-content: space-between;
            `}
          >
              <Tabs />
              <ActionsBar />
          </div>
          <Outlet />
      </>
    )
}

export { Products }
